<template>
  <div class="containerVideoChunkGenerator">
      <div class="containerProgressVideoChunkGenerator"  v-if="!videoUrl">
        <div class="progressBarGenerationChunkLabel">
          {{$t('videoChunkGenerator.generationInProgress')}}
        </div>
        <b-progress class="progressBarGenerationChunk" :type="'is-primary'"/>
      </div>
      <video class="videoChunkGenerator" ref="videoDocumentPreview" v-if="videoUrl" :src="videoUrl" muted />
  </div>
</template>

<script lang="ts">
import { Component, Emit, Prop, Vue, Watch } from "vue-property-decorator";
import store from "@/store";
import { CREATE_TMP_CHUNK_VIDEO } from "@/store/media/mediaAction";
import { Slide } from "@/store/slides2Video/slides2VideoModels";
import { clone } from "@/utils/cloneUtil";
import { updateCurrentSlide } from "@/utils/slides/slideUtil";

export interface VideoMetadata {
  videoWidth: number;
  videoHeight: number;
  duration: number;
}

@Component({})
export default class VideoChunkGenerator extends Vue {


  @Prop({required:true})
  private chunkVideoUrl!:string|null;

  @Prop({required:true})
  private fileID!:string;

  @Prop({required:true})
  private timestampStart!:number;

  @Prop({required:true})
  private timestampEnd!:number;

  private progress:number=0;
  private videoUrl:string|null=null;

  private async mounted(){
    this.initSlide()
  }

  get currentSlideIndex():number{
    return store.getters.getCurrentSlideIndex;
  }
  get currentSlide(): Slide|null {
    if (store.getters.getCurrentSlideIndex > -1) {
      return store.getters.slides[store.getters.getCurrentSlideIndex];
    }
    return null;
  }

  @Watch("currentSlideIndex")
  private async initSlide(){
    this.videoUrl=this.chunkVideoUrl;
    if(!this.videoUrl){
      this.videoUrl=await store.dispatch(CREATE_TMP_CHUNK_VIDEO,
        {fileID:this.fileID,startSeconds:this.timestampStart,endSeconds:this.timestampEnd,progressListener:this.onProgress})
      const newSlide=clone(this.currentSlide) as Slide;
      newSlide.chunkVideoUrl=this.videoUrl||"";
      updateCurrentSlide(newSlide)
    }
    this.$nextTick(() => this.listenVideoMetadata());
  }

  private listenVideoMetadata() {
    const video = this.$refs['videoDocumentPreview'] as HTMLVideoElement;
    if (!video) {
      return;
    }
    video.addEventListener('loadedmetadata', () => {
      this.$emit('video-metadata', {
        videoWidth: video.videoWidth,
        videoHeight: video.videoHeight,
        duration: video.duration,
      } as VideoMetadata);
    });
    // If metadata already loaded (cached video)
    if (video.readyState >= 1) {
      this.$emit('video-metadata', {
        videoWidth: video.videoWidth,
        videoHeight: video.videoHeight,
        duration: video.duration,
      } as VideoMetadata);
    }
  }

  private onProgress(progress:number){
    this.progress=progress
  }


  get isPreviewText2Speech(){
    return store.getters.isPreviewSpeech2Text;
  }

  @Watch('isPreviewText2Speech')
  private controlVideoPlayer(){
    const videoPlayer=this.$refs['videoDocumentPreview'] as HTMLVideoElement;
    if(!videoPlayer){
      return;
    }
    if(this.isPreviewText2Speech){
      videoPlayer.currentTime=0;
      videoPlayer.play();
    }else{
      videoPlayer.currentTime=0;
      videoPlayer.pause();
    }
  }


}
</script>

<style lang="scss" scoped>
.containerVideoChunkGenerator{
  width: 100%;
  height: 100%;
  display: flex;
  justify-items: center;
  align-items: center;

  .containerProgressVideoChunkGenerator{
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-items: center;
    align-items: center;
  }
  .progressBarGenerationChunkLabel{
    color: var(--dark);
    width: 100%;
    text-align: center;
    margin-bottom: 8px;
  }
  .progressBarGenerationChunk{
    margin-left: 64px;
    margin-right: 64px;
    width: calc(100% - 128px);
  }

  .videoChunkGenerator{
    width: 100%;
    height: 100%;
  }
}

</style>
